import { render, staticRenderFns } from "./Whitelisting.vue?vue&type=template&id=0edae554&"
import script from "./Whitelisting.vue?vue&type=script&lang=js&"
export * from "./Whitelisting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports